import { LANGUAGES } from 'Jsx/global';

import { getCategorySelected } from '../FiltersDesktop/utils';
import type { Filters, OrderBy } from '../../types';

import { BreadcrumpItem } from './BreadcrumpSEO/types';

type MapValue = Partial<
  BreadcrumpItem & {
    id: string | number;
    value: string;
    slug: string;
  }
>;

export const getBreadcrumbs = (state: {
  filters: Filters;
  orderBy: OrderBy;
}) => {
  const items = new Map<string, MapValue>();
  const orderBySelected = state.orderBy.itemSelected;
  const { categorySelected, subCategoriesSelected } = getCategorySelected(
    state.filters,
  );

  const subCategory =
    categorySelected &&
    subCategoriesSelected.length > 0 &&
    subCategoriesSelected[0];

  items.set('courses', { name: 'Cursos online', url: 'cursos-online/' });

  if (categorySelected) {
    items.set('category', {
      id: categorySelected.id,
      name: categorySelected.name,
      url: `cursos-${orderBySelected.slug}-${categorySelected.slug}`,
    });
  }

  if (subCategory) {
    items.set('subCategory', {
      id: subCategory.id,
      name: subCategory.name,
      url: `cursos-${orderBySelected.slug}-${subCategory.slug}`,
    });
  }
  if (orderBySelected.slug !== 'online') {
    items.set('orderBy', {
      name: orderBySelected.label,
      url: `cursos-${orderBySelected.slug}`,
      value: orderBySelected.value,
    });
  }

  return items;
};

export const getMetaTitle = (
  state: {
    filters: Filters;
    orderBy: OrderBy;
    userLanguage: LANGUAGES;
  },
  breadcrumbs: Map<string, unknown>,
) => {
  const orderBySelected = state.orderBy.itemSelected;
  const category: any = breadcrumbs.get('category');
  const subCategory: any = breadcrumbs.get('subCategory');
  const { userLanguage } = state;

  const ending = `| Crehana`; // eslint-disable-line prettier/prettier
  const hasOrderBySelected =
    orderBySelected && orderBySelected.slug !== 'online'; // eslint-disable-line prettier/prettier

  const orderByMetaTitlesES = {
    online: `Cursos online recomendados por la comunidad ${ending}`,
    ofertas: `Cursos en oferta`,
    nuevos: `Nuevos Cursos online`,
    gratis: `Cursos Gratis recomendados`,
  };

  const orderByMetaTitlesPT = {
    online: `Cursos recomendados pela comunidade ${ending}`,
    ofertas: `Cursos em oferta`,
    nuevos: `Novos cursos on-line`,
    gratis: `Cursos online gratuitos`,
  };

  const orderByMetaTitles =
    userLanguage === 'pt' ? orderByMetaTitlesPT : orderByMetaTitlesES;
  /**
   * Category/SubCategory metatitle
   */

  if (category || subCategory) {
    const baseCategoryTitle =
      (subCategory && subCategory.name) || (category && category.name);

    if (hasOrderBySelected) {
      if (orderBySelected.slug === 'ofertas') {
        // Cursos
        return `Cursos de ${baseCategoryTitle} en oferta ${ending}`; // eslint-disable-line prettier/prettier
      }
      // ex1: Nuevos Cursos online de Craft | Crehana PE
      // ex2: Cursos online gratis de Craft | Crehana PE
      return `${
        // @ts-expect-error
        orderByMetaTitles[orderBySelected.slug]
      } de ${baseCategoryTitle} ${ending}`; // eslint-disable-line prettier/prettier
    }

    // ex: Cursos de Craft | Crehana PE
    return `Cursos de ${baseCategoryTitle} ${ending}`; // eslint-disable-line prettier/prettier
  }

  /**
   * Software metatitles
   */

  const { softwaresSelected } = state.filters;

  if (softwaresSelected && Object.keys(softwaresSelected).length === 1) {
    const [first] = Object.keys(softwaresSelected);

    if (first) {
      const software = softwaresSelected[first];

      if (software) {
        if (hasOrderBySelected) {
          if (orderBySelected.slug === 'ofertas') {
            return `Cursos de ${software.name} en oferta ${ending}`;
          }
          // ex: Cursos online gratis de InVision | Crehana PE
          // ex: Nuevos Cursos online de InVision | Crehana PE
          // @ts-expect-error
          return `${orderByMetaTitles[orderBySelected.slug]} de ${
            software.name
          } ${ending}`;
        }

        // ex: Cursos de InVision | Crehana PE
        return `Cursos de ${software.name} ${ending}`;
      }
    }
  }

  /**
   * OrderBy metatitles
   */

  // @ts-expect-error
  if (hasOrderBySelected && orderByMetaTitles[orderBySelected.slug]) {
    // return the metatitle for the order by selected
    // ex: Cursos online gratis
    // @ts-expect-error
    return `${orderByMetaTitles[orderBySelected.slug]} ${ending}`;
  }

  // ex: Cursos recomendados por la comunidad | Crehana PE
  return orderByMetaTitles.online;
};
